// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_Y2D","question":"styles_question__iugRx","description":"styles_description__37-cU"};